<div #copilotContainer [ngClass]="{ 'disabled-overlay': loading }">
  <label>{{'widgets.copilot.meetingStartTime' | translate}}</label>
  <div class="dropdown">
    <select class="dropdown__select" [(ngModel)]="selectedMeeting" (change)="onSelectedSessionChanged()">
      <option class="dropdown__item" *ngFor="let meeting of meetings" [ngValue]="meeting">
        {{meeting.startTime | date: "dd.MM.yyyy HH:mm"}}
      </option>
    </select>
    <div class="dropdown__icon">
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
  </div>
  <button class="reload-button" mat-mini-fab color="accent" (click)="refresh()" title="Reload">
    <mat-icon>refresh</mat-icon>
  </button>

  <h4 *ngIf="actionItems && actionItems.length > 0">New Action Items</h4>
  <p *ngFor="let item of actionItems">
    <app-action-item [actionItem]="item" (remove)="onRemoveActionItem($event)"></app-action-item>
  </p>

  <h4 *ngIf="actionItemUpdates && actionItemUpdates.length > 0">Updates</h4>
  <app-action-item-update *ngFor="let update of actionItemUpdates" [update]="update"
    (remove)="onRemoveUpdate($event)" />
</div>
